













































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { debounce } from 'lodash'
import axios from 'axios'
import SectionBase from '@/mixins/SectionBase'
import ServiceSectionBase from './ServiceSectionBase'
import { SERVICE_NAMESPACE } from '@/store/mod/service_form'

export default Vue.extend({
  mixins: [SectionBase, ServiceSectionBase],
  data() {
    return {
      manualPostalPlace: false,
    }
  },
  computed: {
    emailValidation(): string {
      let validation = 'email';
      if ((this as any).value('from') === 'person') {
        validation += '|required';
      }
      return validation;
    },
  },
  methods: {
    fetchPostalCode: debounce(function (this: any, postalCode: string) {
      this.$store.commit(`${SERVICE_NAMESPACE}/setFieldValue`, {
        fieldName: 'postal_place',
        value: '',
      });
      this.$validator.errors.remove('postal_num')

      if (postalCode.length !== 4) {
        return
      }

      axios.get('https://api.bring.com/shippingguide/api/postalCode.json', {
        params: {
          'pnr': postalCode,
          'clientUrl': 'http://corinor.no',
        },
      }).then(response => {
        this.manualPostalPlace = false

        let data = response.data
        if (data.valid) {
          this.$store.commit(`${SERVICE_NAMESPACE}/setFieldValue`, {
            fieldName: 'postal_place',
            value: data.result,
          });
        } else {
          this.$validator.errors.add({
            field: 'postal_num',
            msg: data.result,
          })
        }
      }).catch(error => {
        console.error("Could not fetch postal place, enter manually")
        this.manualPostalPlace = true
      })
    }, 500)
  },
})
